var map = {
	"./Big-Cowboy.png": 404,
	"./Big-Fantasic.png": 800,
	"./Big-Magic.png": 628,
	"./Big-Space.png": 907,
	"./Hansa-Cowboy.png": 617,
	"./Hansa-Fantasic.png": 173,
	"./Hansa-Magic.png": 511,
	"./Hansa-Space.png": 332,
	"./Josh-Cowboy.png": 736,
	"./Josh-Fantasic.png": 884,
	"./Josh-Magic.png": 880,
	"./Josh-Space.png": 399,
	"./Sara-Cowboy.png": 889,
	"./Sara-Fantasic.png": 837,
	"./Sara-Magic.png": 7,
	"./Sara-Space.png": 444,
	"./Total-Cowboy.png": 604,
	"./Total-Fantasic.png": 960,
	"./Total-Magic.png": 460,
	"./Total-Space.png": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;